import useConfirmDiscard from '@boHooks/useConfirmDiscard';
import { useState } from 'react';

// Tab selection, starting on `initialTab`, where leaving `guardedTab` with unsaved changes asks for
// confirmation first. `reportDirty(dirty)` records the unsaved state and forwards it to `onDirtyChange`.
const useGuardedTabs = (guardedTab, onDirtyChange = () => {}, initialTab = 0) => {
    const [activeTab, setActiveTab] = useState(initialTab);
    const [dirty, setDirty] = useState(false);
    const confirmDiscard = useConfirmDiscard();

    const reportDirty = (value) => {
        setDirty(value);
        onDirtyChange(value);
    };

    const selectTab = (index) => {
        if (index === activeTab) return;
        if (activeTab !== guardedTab || !dirty) {
            setActiveTab(index);
            return;
        }
        confirmDiscard({
            onConfirm: () => {
                reportDirty(false);
                setActiveTab(index);
            },
        });
    };

    return { activeTab, selectTab, reportDirty };
};

export default useGuardedTabs;
